<dx-popup
  [visible]="isVisible"
  [width]="460"
  [height]="'62vh'"
  [minHeight]="360"
  [showTitle]="true"
  title="Panel Aliases"
  [closeOnOutsideClick]="false"
  [dragEnabled]="true"
  [resizeEnabled]="false"
  (onShowing)="onShowing()"
  (onHidden)="onHidden()">
  <div *dxTemplate="let data of 'content'" class="root">
    <div class="hint">Short names for the tab strip. Empty means the full panel name.</div>
    <dx-scroll-view class="rows" height="100%" [useNative]="false" [showScrollbar]="'onHover'">
      <div class="row" *ngFor="let row of rows">
        <div class="label" [title]="row.fullName">{{row.fullName}}</div>
        <div class="input">
          <dx-text-box [value]="row.alias"
                       [showClearButton]="true"
                       valueChangeEvent="input"
                       (onValueChanged)="onAliasChanged(row, $event)">
          </dx-text-box>
        </div>
      </div>
    </dx-scroll-view>
    <div class="footer">
      <dx-button text="Save" type="success" [width]="110" (onClick)="save()"></dx-button>
      <dx-button text="Cancel" [width]="110" (onClick)="cancel()"></dx-button>
    </div>
  </div>
</dx-popup>
